module.exports = __webpack_public_path__ + "static/media/showcase_icon.7d6ef61a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_icon.png
// module id = 834
// module chunks = 0